import { lazy, Suspense } from 'react';
import { useParams } from 'react-router';
import Loader from '../../views/common/Loader';

const WorkOrderViewPage = lazy(() => import('./WorkOrderViewPage'));
const NotFound = lazy(() => import('../../app/views/NotFound'));

const WorkOrderView = () => {
  const { workOrderId } = useParams();

  return (
    <Suspense
      fallback={
        <div className="lazy-loading">
          <Loader size={80} />
        </div>
      }
    >
      <WorkOrderViewPage workOrderId={workOrderId} />
    </Suspense>
  );
};

const workOrderRoutes = [
  {
    path: ':workOrderId',
    children: [
      { index: true, element: <WorkOrderView /> },
      { path: 'shipment', element: <WorkOrderView /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default workOrderRoutes;
